
export interface ElementOptions {
    id?: string;
    className?: string;
    text?: string;
}

export function newElement<K extends keyof HTMLElementTagNameMap>(
    tagName: K,
    options: ElementOptions = {},
): HTMLElementTagNameMap[K] {
    const element = document.createElement(tagName);

    if (options.id !== undefined) element.id = options.id;
    if (options.className !== undefined) element.className = options.className;
    if (options.text !== undefined) element.textContent = options.text;

    return element;
}
